import { JsonObject, JsonProperty } from 'json2typescript';
import { AdvancedSearchRequestInterface } from '../interfaces/advancedSearchRequest.interface';

@JsonObject('AdvancedSearchRequestModel')
export class AdvancedSearchRequestModel
  implements AdvancedSearchRequestInterface
{
  @JsonProperty('KeyWord', String)
  KeyWord: string = undefined;

  @JsonProperty('AssetTypeIds', String)
  AssetTypeIds: string = undefined;

  @JsonProperty('AssetClassIds', String)
  AssetClassIds: string = undefined;

  @JsonProperty('NumResults', Number)
  NumResults: number = undefined;

  @JsonProperty('MarketId', String)
  MarketId: string = undefined;

  @JsonProperty('OnlyFavourites', Boolean, true)
  OnlyFavourites: boolean = undefined;
}
